import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { AppStateService } from '@/core/services/app-state.service';

export const speakerValidationGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const appState = inject(AppStateService);
    const router = inject(Router);

    const isUploadPage = state.url.includes('/conversations/upload-conversation');

    return combineLatest([
        appState.jobsLoading$,
        appState.analyses$,
        appState.selectedAnalysis$
    ]).pipe(
        // wait until backend refreshJobs() is finished
        filter(([isLoading]) => !isLoading),
        take(1),
        map(([_, analyses, selectedAnalysis]) => {
            const allAnalyses = analyses || [];

            const analysisNeedingSpeaker = allAnalyses.find(a =>
                !a.speakers ||
                a.speakers.some((s: any) => !s.validated)
            );

            // no analysis at all => upload page is allowed
            if (!allAnalyses.length) {
                return isUploadPage ? true : router.createUrlTree(['/dashboard']);
            }

            // if any analysis needs speaker validation, force dashboard
            if (analysisNeedingSpeaker) {
                router.navigate(['/dashboard']);
                return false;
            }

            // analysis exists and validated => allow
            return true;
        })
    );
};